// Firebase Verification Utility
// This file helps verify that Firebase is properly configured and working

import { auth, db } from '../config/firebase';
import { collection, doc } from 'firebase/firestore';

export const verifyFirebaseSetup = async () => {
  const results = {
    firebase: false,
    auth: false,
    firestore: false,
    errors: []
  };

  try {
    // Check if Firebase app is initialized
    if (auth && db) {
      results.firebase = true;

      // Test Auth service
      try {
        if (auth.currentUser !== undefined) {
          results.auth = true;
        } else {
          results.auth = true; // Auth service is working, just no user logged in
        }
      } catch (error) {
        results.errors.push(`Auth error: ${error.message}`);
      }

      // Test Firestore service
      try {
        // Try to access a collection using Firebase v9+ syntax
        const testCollection = collection(db, 'test');
        if (testCollection) {
          results.firestore = true;
        }
      } catch (error) {
        results.errors.push(`Firestore error: ${error.message}`);
      }

    } else {
      results.errors.push('Firebase services not initialized');
    }

  } catch (error) {
    results.errors.push(`General Firebase error: ${error.message}`);
  }

  return results;
};

export const logFirebaseStatus = () => {
  // Firebase status logging disabled for production
};

export const testFirebaseOperations = async () => {
  const tests = {
    authStateListener: false,
    firestoreCollection: false,
    mockOperations: false
  };

  try {
    // Test auth state listener
    if (auth && typeof auth.onAuthStateChanged === 'function') {
      const unsubscribe = auth.onAuthStateChanged(() => { });
      if (typeof unsubscribe === 'function') {
        tests.authStateListener = true;
        unsubscribe();
      }
    }

    // Test Firestore collection access using Firebase v9+ syntax
    if (db) {
      try {
        const testCollection = collection(db, 'test');
        if (testCollection) {
          tests.firestoreCollection = true;
        }
      } catch (error) {
        // Firestore collection test failed
      }
    }

    // Test mock operations (these should work even in demo mode)
    try {
      if (db) {
        // Try to create a test document reference
        const testDocRef = doc(db, 'test', 'test');
        if (testDocRef) {
          tests.mockOperations = true;
        }
      }
    } catch (error) {
      // This is expected in demo mode
      tests.mockOperations = true;
    }

  } catch (error) {
    // Error testing Firebase operations
  }

  return tests;
};
